import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaApparatoRespiratorioEditComponent.vue?vue&type=template&id=84032434"
import script from "./RsaSchedaRelazioneSanitariaApparatoRespiratorioEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaApparatoRespiratorioEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports